<arm-form (submitForm)="submit()" [disableSubmit]="isUnauthorized" class="cac-configuration">
  <arm-form-title>CAC Profiles Configuration</arm-form-title>
  <div class="settings-section">
    <mat-form-field class="halfWidth">
      <mat-label>CAC Profiles Threshold</mat-label>
      <input matInput [(ngModel)]="cacProfilesConfiguration.warningThreshold" type="number" min="1" max="100" name="warningThreshold" required="true">
      <span matSuffix>%</span>
    </mat-form-field>

    <mat-checkbox name="cacProfilesConfigurationEnabled" color="primary" [(ngModel)]="cacProfilesConfiguration.enabled">
      Enable Session Counting (for CAC and Statistics)
    </mat-checkbox>
  </div>
</arm-form>
